import _ from "lodash";

import {
  FETCH_SLIDES,
  FETCH_SLIDES_SUCCESS,
  ADD_SLIDE,
  ADD_SLIDE_SUCCESS,
  ADD_SLIDE_FAIL,
  DELETE_SLIDE,
  DELETE_SLIDE_SUCCESS,
  DELETE_SLIDE_FAIL,
} from "../actions/Slideshow";

const INITIAL_STATE = {
  slides: {},
  sortedSlides: [],
  isSlideLoading: false,
  error: null,
};

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case DELETE_SLIDE:
    case ADD_SLIDE:
    case FETCH_SLIDES:
      return { ...state, isSlideLoading: true };
    case FETCH_SLIDES_SUCCESS:
      return {
        ...state,
        isSlideLoading: false,
        slides: action.payload,
        sortedSlides: action.sorted,
      };
    case DELETE_SLIDE_SUCCESS:
    case ADD_SLIDE_SUCCESS:
      return {
        ...state,
        isSlideLoading: false,
        // slides: action.payload,
        // sortedSlides: action.sorted,
        error: null,
      };
    case ADD_SLIDE_FAIL:
    case DELETE_SLIDE_FAIL:
      return {
        ...state,
        isSlideLoading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/SlideshowReducer.js